// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1p8e-","footer":"ReportModalFilter_footer__382Te"};